import React, {useState} from "react";
import {useSelector} from "react-redux";
import {IApiKey} from "../models/ApiKey";
import {RootState} from "../store/rootReducer";
import {
    CommandBar,
    IColumn,
    ICommandBarItemProps,
    PrimaryButton,
    SelectionMode,
    ShimmeredDetailsList
} from "@fluentui/react";
import NewApiKeyDialog from "../components/ApiKeyManagement/NewApiKeyDialog";
import ApiKeyDetailsDialog from "../components/ApiKeyManagement/ApiKeyDetailsDialog";
import {useGetApiKeysQuery} from "../store/Api";
import {useGetOrganizationsQuery} from "../store/endpoints/OrganizationsEndpoints";
import useCan, {API_KEYS_SELF} from "../permissions/ability";
import { useUrlPanelState } from '../hooks/useUrlState';

const ApiKeyManagementPage: React.FC = () => {
    const organization = useSelector((state: RootState) => state.settings.selectedOrganization)
    const activeUser = useSelector((state: RootState) => state.auth.userName)

    const getOrganizations = useGetOrganizationsQuery({username: activeUser ?? ''}, {skip: !activeUser || activeUser === ''});
    const [newDialogOpen, setNewDialogOpen] = useState<boolean>(false);
    /*
     * The details dialog opens from the URL (?panel=apiKey&instance=<id>) so a link can reach one
     * key. Creating a key stays local — it has no id to link to until it exists.
     */
    const apiKeyPanel = useUrlPanelState('apiKey');
    const apiKeysApi = useGetApiKeysQuery();
    const detailsKey = apiKeyPanel.isOpen
        ? apiKeysApi.data?.find((k) => k.id === apiKeyPanel.instanceId)
        : undefined;
    let org = organization;
    if (org == null && getOrganizations.data !== undefined && getOrganizations.data.length > 0)
        org = getOrganizations.data[0].id;
    

    const columns: IColumn[] = [
        {
            key: 'Name',
            name: 'Name',
            fieldName: 'name',
            minWidth: 100,
            isRowHeader: true,
        },
        {
            key: 'Enabled',
            name: 'Enabled',
            fieldName: 'enabled',
            onRender: (key: IApiKey) => key.enabled ? "✓" : "",
            minWidth: 100,
            maxWidth: 100,
        },
        {
            key: 'Type',
            name: 'Key Type',
            fieldName: 'keyType',
            minWidth: 100,
            maxWidth: 200,
        },
        {
            key: 'Details',
            name: '',
            minWidth: 100,
            onRender: (key: IApiKey) => <PrimaryButton
                text='Details'
                onClick={() => {
                    apiKeyPanel.open(key.id);
                }}
                />
        }
    ]

    const commands: ICommandBarItemProps[] = [
        {
            key: 'new',
            text: 'New',
            iconProps: { iconName: 'Add' },
            onClick: () => {
                setNewDialogOpen(true);
            }
        }
    ]

    const canManageKeys = useCan(API_KEYS_SELF);

    return (
        <div className='main-content'>
            <h1>API Key Management</h1>
            <p>Organization: {org}</p>
            {canManageKeys && (
            <CommandBar items={commands} />
            )}
            <ShimmeredDetailsList items={apiKeysApi.data ?? []} enableShimmer={apiKeysApi.isFetching} columns={columns} selectionMode={SelectionMode.none} />
            <NewApiKeyDialog
                onClose={() => {setNewDialogOpen(false);}}
                isOpen={newDialogOpen}
                />
            <ApiKeyDetailsDialog onClose={() => apiKeyPanel.close()} apiKey={detailsKey} />
        </div>
    );
}

export default ApiKeyManagementPage;